export type ClientMatchFields = "fantasy_name" | "client" | "client_id";

export class GetClientsParams {
  public client = "";
  public bySalesman = true;
  public page = 1;
  public limit = 10;
  public columns: ClientMatchFields[] = [];
}
